import {LOCALE_ID, Component, HostListener, ViewChild, ViewEncapsulation, Inject, EventEmitter, Output, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { PrimeNGConfig } from 'primeng/api';
import { LoadingBarService } from '@ngx-loading-bar/core';

import { AppService } from '../../../services/app.service';
import { SystemService } from '../../../services/system.service';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { AlertType, DialogType, OptionType } from '../../../enumerators/messages.enum';
import { BnNgIdleService } from 'bn-ng-idle';
import { MessageService } from '../../../services/message.service';
import { MessageComponent } from '../../messages/message/message.component';
import { DialogOption } from '../../../models/dialog-option.model';
import locales from '@angular/common/locales/es-MX';
import {registerLocaleData} from '@angular/common';
import { NotificacionesService } from '../../../services/notificaciones.service';
registerLocaleData(locales,'es');

@Component({
  selector: 'app-main',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './main.component.html',
  providers: [{ provide: LOCALE_ID, useValue: 'es' }],
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  @ViewChild('message') messageComponent!: MessageComponent;

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  @Output() onResize: EventEmitter<any> = new EventEmitter<any>();

  @HostListener('window:mousemove') userMouseMove() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('document:tap') userTap() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('document:click') userClick(event: any) {
    clearTimeout(this.userActivity);
    this.setTimeout();

    this.onClick.emit(event);
  }

  @HostListener('document:mousewheel') userScroll() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('document:keydown') userKey() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  @HostListener('window:resize', ['$event'])
  private onListenerResize(event: any): void {
    this.onResize.emit(event);
  }


  userActivity: any;
  alertatimerIniciada: boolean = false;

  constructor(
    public appService: AppService, 
    private readonly systemService: SystemService, 
    @Inject(DOCUMENT) private readonly document: Document, 
    private readonly router: Router, 
    private readonly translateService: TranslateService, 
    private readonly userService: UserService, 
    private readonly messageService: MessageService, 
    private readonly configNg: PrimeNGConfig, 
    private readonly notificacionesService: NotificacionesService
  ) {
    let themeLink = this.document.getElementById('app-themes') as HTMLLinkElement;
    const tema: string | null = localStorage.getItem('tema');

    if (themeLink) {
      themeLink.href = tema ? tema : "md-light-indigo.css";
    }
    this.router.events.subscribe(value => {
      if (value instanceof NavigationEnd) {
        this.systemService.activateOptionMenu(value.urlAfterRedirects);
      }
    });

    this.appService.startIdleCount.subscribe((value) => {
      if (value) {
        this.setTimeout();
      }
    });

    this.appService.sessionEnded.subscribe((value) => {
      if (value) {
        this.showResumeSession();
      }
    });

    this.notificacionesService.requestPermission();
    this.notificacionesService.listenForMessages();

    configNg.ripple = true;
  }

  ngOnInit() {
    this.notificacionesService.getToken();
    this.translateService.get('primeng').subscribe(res => this.configNg.setTranslation(res));
  }

  setTimeout() {
    if (localStorage.getItem(this.systemService.localStoreVariable.JWT) && this.systemService.user?.userType?.inactivityTime) {
      if (this.alertatimerIniciada) {
        this.messageComponent.closeAlertTimer();
        this.alertatimerIniciada = false;
      }

      this.userActivity = setTimeout(() => {
        this.alertatimerIniciada = true;
        this.messageService.timerAlert(AlertType.Warning, this.translateService.instant("TiempoInactividadAlerta"), 60).then((terminado: boolean) => {
          if (terminado) {
            this.messageService.alert(AlertType.Warning, this.translateService.instant("TiempoInactividad"), false);
            this.userService.logOut;
            this.messageComponent.closeDialog();
          }
        });

      }, this.systemService.user.userType?.inactivityTime);
    }
  }

  showResumeSession() {
    if (localStorage.getItem(this.systemService.localStoreVariable.JWT)) {
      let options = [];

      options.push(new DialogOption({ title: this.translateService.instant("SesionFinalizado.Si"), value: 1 }));
      options.push(new DialogOption({ title: this.translateService.instant("SesionFinalizado.No"), value: 2, type: OptionType.Negative }));

      this.messageService.dialog(DialogType.Advise, "", this.translateService.instant("SesionFinalizado.Mensaje"), options).then((response: any) => {
        if (response == 1) {
          this.userService.resumeSession();
        }
        else if (response == 2) {
          this.userService.logOut();
        }
      });
    }
  }
}
